var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCommunicationFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 19,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#40ADE2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.313,
  d: "M10.17 1.327c-4.744 0-8.592 3.727-8.592 8.324 0 1.556.448 3.01 1.218 4.256l-1.09 3.944 4.071-1.056a8.73 8.73 0 0 0 4.394 1.18c4.744 0 8.592-3.728 8.592-8.324 0-4.597-3.848-8.324-8.593-8.324M6.06 7.841h8.22M6.06 10.013h8.22M6.06 12.184h8.22"
})));
export default SvgCommunicationFilled;